/**
 * Base class for ItemsAggregateMemory and SentencesAggregateMemory.
 */
export class DomainAggregateMemory {
  constructor(attrs = {}) {
    _.defaults(this, attrs, {
      progress: 0,
      skippedItemsCount: 0,
      studiedItemsCount: 0,
      eligibleItemsCount: 0,
      lastStudyTime: null,
      seeNextAt: null,
      totalStudyTimeMillis: 0,
      itemsAtCheckpoint0: 0,
      itemsAtCheckpoint1: 0,
      itemsAtCheckpoint2: 0,
      itemsAtCheckpoint3: 0,
      averageReviewInterval: null,
      averageEasinessModifier: null,
      averageCurrentRetention: null,
      difficultyBucket: null,
    });

    if (this.lastStudyTime && !(this.lastStudyTime instanceof Date)) {
      this.lastStudyTime = new Date(this.lastStudyTime);
    }

    if (this.seeNextAt && !(this.seeNextAt instanceof Date)) {
      this.seeNextAt = new Date(this.seeNextAt);
    }
  }

  /**
   * Returns the items that are exclusively at checkpoint1.
   *
   * @returns {Number}
   */
  getItemsAtCheckpoint1() {
    return this.itemsAtCheckpoint1 - this.itemsAtCheckpoint2;
  }

  getItemsAtCheckpoint0() {
    return this.studiedItemsCount - this.itemsAtCheckpoint1;
  }

  isReadyToStudy() {
    const now = new Date();

    return this.seeNextAt && this.seeNextAt < now;
  }

  get totalStudyTime() {
    return Math.round(this.totalStudyTimeMillis / 1000);
  }
}

export class ItemsAggregateMemory extends DomainAggregateMemory {
  constructor(attrs = {}, isCompleteGoal = false) {
    super(attrs);

    if (isCompleteGoal) {
      this.progress = 100;
    }
  }
}

export class SentencesAggregateMemory extends DomainAggregateMemory {
  constructor(attrs = {}) {
    super(attrs);
  }

  get level() {
    if (this.progress >= 67) {
      return 3;
    } else if (this.progress >= 34) {
      return 2;
    } else if (this.progress >= 1) {
      return 1;
    }

    return 0;
  }
}
